import React, { Fragment, useState, useCallback, useMemo } from 'react';
import IconMarkUp from '../Icon-markup';
import { Container, Row } from 'reactstrap';
import { ArrowsDirection, WebApp, Control, TextEditor, Brand } from '../../../Constant';
import { Breadcrumbs } from '../../../AbstractElements';
import ThemifyCommon from './ThemifyCommon';

const ThemifyIcons = () => {
  const [iTag, setiTag] = useState('');
  const [icon, setIcon] = useState('');
  const data = useMemo(
    () => [
      {
        directional: ['ti-arrow-up', 'ti-arrow-right', 'ti-arrow-left', 'ti-arrow-down'],
        webapp: ['ti-save', 'ti-direction-alt', 'ti-user', 'ti-settings'],
        control: ['ti-control-play', 'ti-control-pause'],
        texteditor: ['ti-paragraph', 'ti-underline', 'ti-text'],
        brand: ['ti-facebook', 'ti-twitter', 'ti-instagram'],
      },
    ],
    []
  );

  const callback = useCallback((tag) => {
    setiTag({
      iTag: '<i className= "' + tag + '"></i>',
    });
    setIcon({
      icon: '' + tag + ' fa-2x',
    });
  }, []);
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Themify Icon' parent='Icons' title='Themify Icon' />
      <Container fluid={true}>
        {data.map((icons, index) => {
          return (
            <Row key={index}>
              <ThemifyCommon iconType={icons.directional} title={ArrowsDirection} parentCallback={callback} />
              <ThemifyCommon iconType={icons.webapp} title={WebApp} parentCallback={callback} />
              <ThemifyCommon iconType={icons.control} title={Control} parentCallback={callback} />
              <ThemifyCommon iconType={icons.texteditor} title={TextEditor} parentCallback={callback} />
              <ThemifyCommon iconType={icons.brand} title={Brand} parentCallback={callback} />
            </Row>
          );
        })}
      </Container>
      <IconMarkUp itag={iTag} icons={icon} />
    </Fragment>
  );
};

export default ThemifyIcons;
